import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import SearchBar from "../components/SearchBar";
import ListingCard from "../components/ListingCard";
import { Loader2, SearchX } from "lucide-react";

export default function Search() {
  const [params] = useSearchParams();
  const category = params.get("category") || "";
  const location = params.get("location") || "";
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const q = {};
    if (category) q.category = category;
    if (location) q.location = location;
    api.get("/listings", { params: q })
      .then((r) => setRows(r.data))
      .catch(() => setRows([]))
      .finally(() => setLoading(false));
  }, [category, location]);

  const place = /^[a-z]{1,2}\d/i.test(location) ? location.toUpperCase() : location.replace(/\b\w/g, (c) => c.toUpperCase());
  const title = `${category || "All services"}${location ? ` near ${place}` : ""}`;

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid="search-page">
      <p className="text-xs font-mono uppercase tracking-widest text-zinc-500 mb-2">Directory</p>
      <h1 className="font-display text-4xl md:text-5xl font-bold tracking-tighter mb-6" data-testid="search-title">{title}</h1>
      <SearchBar initialCategory={category} initialLocation={location} />

      <div className="mt-10">
        {loading ? (
          <div className="flex items-center gap-2 text-zinc-500"><Loader2 className="w-4 h-4 animate-spin" /> Searching...</div>
        ) : rows.length === 0 ? (
          <div className="border-2 border-dashed border-zinc-200 rounded-lg p-16 text-center" data-testid="search-empty">
            <SearchX className="w-10 h-10 mx-auto text-zinc-300 mb-3" />
            <p className="font-display text-xl font-bold">No businesses found yet</p>
            <p className="text-sm text-zinc-600 mt-1">Try another town or service — or <Link to="/register" className="underline font-medium">list your own business</Link>.</p>
          </div>
        ) : (
          <>
            <p className="text-sm text-zinc-500 mb-4" data-testid="search-count">{rows.length} {rows.length === 1 ? "business" : "businesses"}</p>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="search-results">
              {rows.map((l) => <ListingCard key={l.id} listing={l} />)}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
